import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <img
        src="/kolanut_logo.png"
        alt="Kolanut"
        className="h-14 w-14 object-contain mb-6"
      />
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gray-400 mb-3">
        404
      </p>
      <h1 className="font-serif text-3xl sm:text-4xl text-gray-900 tracking-tight">
        Not found
      </h1>
      <p className="mt-3 text-base text-gray-500 max-w-sm">
        This page doesn&apos;t exist or the link may be outdated.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center justify-center h-12 px-8 rounded-full bg-[#8ae690] text-black font-semibold text-sm shadow-md hover:bg-[#7ad67f] hover:shadow-lg transition-all duration-200"
      >
        Go home
      </Link>
    </div>
  );
};

export default NotFoundPage;
